<template>
  <div
    class="modal fade"
    id="pdfModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="pdfModalLabel"
    aria-hidden="true"
    ref="modalEle"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-5" id="pdfModalLabel">
            Ver {{ displayName }}
          </h5>
          <button
            class="btn-close"
            type="button"
            @click="hide()"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body p-0">
          <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            width="100%"
            height="700px"
            style="border: none"
          ></iframe>
          <div v-else class="text-center p-5 text-muted">
            No se pudo encontrar el documento o verifique su conexión a internet
            e intente nuevamente más tarde.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Modal } from "bootstrap";
import { ref, onMounted, computed } from "vue";

const props = defineProps({
  event: Object,
  source: String,
});

const baseServerUrl = process.env.VUE_APP_SERVER_SIDE_URL;

const modalEle = ref(null);
let modalObj = null;

onMounted(() => {
  modalObj = new Modal(modalEle.value);
});

const displayName = computed(() => {
  switch (props.source) {
    case "poster":
      return "Afiche";
    case "banner":
      return "Banner";
    case "regulation":
      return "Reglamento (PDF)";
    default:
      return "Documento";
  }
});

const pdfUrl = computed(() => {
  const filename = props.event?.[props.source];

  if (filename) {
    return `${baseServerUrl}/${filename}`;
  }
  return null;
});

function show() {
  modalObj?.show();
}

function hide() {
  modalObj?.hide();
}

defineExpose({ show, hide });
</script>

<style scoped>
.modal-xl {
  max-width: 90%;
}
</style>
